module.exports = __webpack_public_path__ + "img/blog-header-frame.abfac03a.png";